(function () {
    'use strict';

    angular.module("imApp").factory("emailTemplateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEmailTemplate: function (parms) {
                return $ihttp.post({
                    method: 2897,
                    parameters: parms || {}
                });
            },
            listWebPages: function (parms) {
                return $ihttp.post({
                    method: 2899,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2898,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2900,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
